/* tslint:disable */
/* eslint-disable */
/**
 * unmatchedOrderManage API
 * 未照合・差異一覧の情報を操作するAPI
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 *
 * @export
 * @interface BulkDeleteUnmatchedOrderRequest
 */
export interface BulkDeleteUnmatchedOrderRequest {
    /**
     *
     * @type {Array<DeleteUnmatchedOrderId>}
     * @memberof BulkDeleteUnmatchedOrderRequest
     */
    'bulkDeleteUnmatchedOrderIds': Array<DeleteUnmatchedOrderId>;
}
/**
 *
 * @export
 * @interface BulkDeleteUnmatchedOrderResult
 */
export interface BulkDeleteUnmatchedOrderResult {
    /**
     *
     * @type {Array<string>}
     * @memberof BulkDeleteUnmatchedOrderResult
     */
    'deletedUnmatchedOrderIds': Array<string>;
}
/**
 *
 * @export
 * @interface BulkDeleteUnmatchedOrderSuccessResponse
 */
export interface BulkDeleteUnmatchedOrderSuccessResponse {
    /**
     *
     * @type {number}
     * @memberof BulkDeleteUnmatchedOrderSuccessResponse
     */
    'statusCode': number;
    /**
     *
     * @type {number}
     * @memberof BulkDeleteUnmatchedOrderSuccessResponse
     */
    'code': number;
    /**
     *
     * @type {string}
     * @memberof BulkDeleteUnmatchedOrderSuccessResponse
     */
    'message': string;
    /**
     *
     * @type {BulkDeleteUnmatchedOrderResult}
     * @memberof BulkDeleteUnmatchedOrderSuccessResponse
     */
    'result': BulkDeleteUnmatchedOrderResult;
}
/**
 *
 * @export
 * @interface BulkRegisterOrderBusinessesFromUnmatchedRequest
 */
export interface BulkRegisterOrderBusinessesFromUnmatchedRequest {
    /**
     *
     * @type {Array<string>}
     * @memberof BulkRegisterOrderBusinessesFromUnmatchedRequest
     */
    'unmatchedOrderIds': Array<string>;
}
/**
 *
 * @export
 * @interface BulkRegisterOrderBusinessesFromUnmatchedResult
 */
export interface BulkRegisterOrderBusinessesFromUnmatchedResult {
    /**
     * 登録に成功した発注数
     * @type {number}
     * @memberof BulkRegisterOrderBusinessesFromUnmatchedResult
     */
    'registeredCount': number;
    /**
     *
     * @type {BulkRegisterOrderBusinessesFromUnmatchedResultRejectedUnmatchedOrders}
     * @memberof BulkRegisterOrderBusinessesFromUnmatchedResult
     */
    'rejectedUnmatchedOrders': BulkRegisterOrderBusinessesFromUnmatchedResultRejectedUnmatchedOrders;
}
/**
 *
 * @export
 * @interface BulkRegisterOrderBusinessesFromUnmatchedResultRejectedUnmatchedOrders
 */
export interface BulkRegisterOrderBusinessesFromUnmatchedResultRejectedUnmatchedOrders {
    /**
     *
     * @type {Array<string>}
     * @memberof BulkRegisterOrderBusinessesFromUnmatchedResultRejectedUnmatchedOrders
     */
    'duplicateRequest'?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof BulkRegisterOrderBusinessesFromUnmatchedResultRejectedUnmatchedOrders
     */
    'unmatchedOrderNotFound'?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof BulkRegisterOrderBusinessesFromUnmatchedResultRejectedUnmatchedOrders
     */
    'missingRequired'?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof BulkRegisterOrderBusinessesFromUnmatchedResultRejectedUnmatchedOrders
     */
    'aggregateBusinessNotFound'?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof BulkRegisterOrderBusinessesFromUnmatchedResultRejectedUnmatchedOrders
     */
    'alreadyRegistered'?: Array<string>;
}
/**
 *
 * @export
 * @interface BulkRegisterOrderBusinessesFromUnmatchedSuccessResponse
 */
export interface BulkRegisterOrderBusinessesFromUnmatchedSuccessResponse {
    /**
     *
     * @type {number}
     * @memberof BulkRegisterOrderBusinessesFromUnmatchedSuccessResponse
     */
    'statusCode': number;
    /**
     *
     * @type {number}
     * @memberof BulkRegisterOrderBusinessesFromUnmatchedSuccessResponse
     */
    'code': number;
    /**
     *
     * @type {string}
     * @memberof BulkRegisterOrderBusinessesFromUnmatchedSuccessResponse
     */
    'message': string;
    /**
     *
     * @type {BulkRegisterOrderBusinessesFromUnmatchedResult}
     * @memberof BulkRegisterOrderBusinessesFromUnmatchedSuccessResponse
     */
    'result': BulkRegisterOrderBusinessesFromUnmatchedResult;
}
/**
 *
 * @export
 * @interface DeleteUnmatchedOrderId
 */
export interface DeleteUnmatchedOrderId {
    /**
     *
     * @type {string}
     * @memberof DeleteUnmatchedOrderId
     */
    'unmatchedOrderId': string;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     *
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     *
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     *
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 *
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     *
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     *
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     *
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 *
 * @export
 * @interface ExistingOrderInfo
 */
export interface ExistingOrderInfo {
    /**
     *
     * @type {string}
     * @memberof ExistingOrderInfo
     */
    'orderId': string;
    /**
     *
     * @type {string}
     * @memberof ExistingOrderInfo
     */
    'warehouseNumber': string;
    /**
     *
     * @type {string}
     * @memberof ExistingOrderInfo
     */
    'warehouse': string;
    /**
     *
     * @type {string}
     * @memberof ExistingOrderInfo
     */
    'supplierNumber': string;
    /**
     *
     * @type {string}
     * @memberof ExistingOrderInfo
     */
    'supplierName': string;
    /**
     *
     * @type {string}
     * @memberof ExistingOrderInfo
     */
    'businessNumber': string;
    /**
     *
     * @type {string}
     * @memberof ExistingOrderInfo
     */
    'businessName': string;
    /**
     *
     * @type {string}
     * @memberof ExistingOrderInfo
     */
    'package': string;
    /**
     *
     * @type {string}
     * @memberof ExistingOrderInfo
     */
    'orderIssuedNumber'?: string | null;
    /**
     *
     * @type {string}
     * @memberof ExistingOrderInfo
     */
    'orderNumber'?: string | null;
    /**
     *
     * @type {number}
     * @memberof ExistingOrderInfo
     */
    'createdOrderDate'?: number | null;
    /**
     *
     * @type {number}
     * @memberof ExistingOrderInfo
     */
    'desiredDeliveryDate': number;
    /**
     *
     * @type {number}
     * @memberof ExistingOrderInfo
     */
    'estimatedTimeOfArrival': number;
    /**
     *
     * @type {string}
     * @memberof ExistingOrderInfo
     */
    'orderAmount': string;
    /**
     *
     * @type {string}
     * @memberof ExistingOrderInfo
     */
    'orderStatus': string;
    /**
     *
     * @type {number}
     * @memberof ExistingOrderInfo
     */
    'updateAt': number;
}
/**
 *
 * @export
 * @interface GetExistingOrdersResult
 */
export interface GetExistingOrdersResult {
    /**
     *
     * @type {PagingOptions}
     * @memberof GetExistingOrdersResult
     */
    'pagingOptions'?: PagingOptions;
    /**
     *
     * @type {Array<ExistingOrderInfo>}
     * @memberof GetExistingOrdersResult
     */
    'existingOrders': Array<ExistingOrderInfo>;
}
/**
 *
 * @export
 * @interface GetExistingOrdersSuccessResponse
 */
export interface GetExistingOrdersSuccessResponse {
    /**
     *
     * @type {number}
     * @memberof GetExistingOrdersSuccessResponse
     */
    'statusCode': number;
    /**
     *
     * @type {number}
     * @memberof GetExistingOrdersSuccessResponse
     */
    'code': number;
    /**
     *
     * @type {string}
     * @memberof GetExistingOrdersSuccessResponse
     */
    'message': string;
    /**
     *
     * @type {GetExistingOrdersResult}
     * @memberof GetExistingOrdersSuccessResponse
     */
    'result': GetExistingOrdersResult;
}
/**
 *
 * @export
 * @interface GetUnmatchedOrderFilterSuccessResponse
 */
export interface GetUnmatchedOrderFilterSuccessResponse {
    /**
     *
     * @type {number}
     * @memberof GetUnmatchedOrderFilterSuccessResponse
     */
    'statusCode': number;
    /**
     *
     * @type {number}
     * @memberof GetUnmatchedOrderFilterSuccessResponse
     */
    'code': number;
    /**
     *
     * @type {string}
     * @memberof GetUnmatchedOrderFilterSuccessResponse
     */
    'message': string;
    /**
     *
     * @type {Array<string>}
     * @memberof GetUnmatchedOrderFilterSuccessResponse
     */
    'result': Array<string>;
}
/**
 *
 * @export
 * @interface GetUnmatchedOrderResult
 */
export interface GetUnmatchedOrderResult {
    /**
     *
     * @type {PagingOptions}
     * @memberof GetUnmatchedOrderResult
     */
    'pagingOptions': PagingOptions;
    /**
     *
     * @type {Array<UnmatchedOrderInfo>}
     * @memberof GetUnmatchedOrderResult
     */
    'unmatchedOrders': Array<UnmatchedOrderInfo>;
}
/**
 *
 * @export
 * @interface GetUnmatchedOrderSuccessResponse
 */
export interface GetUnmatchedOrderSuccessResponse {
    /**
     *
     * @type {number}
     * @memberof GetUnmatchedOrderSuccessResponse
     */
    'statusCode': number;
    /**
     *
     * @type {number}
     * @memberof GetUnmatchedOrderSuccessResponse
     */
    'code': number;
    /**
     *
     * @type {string}
     * @memberof GetUnmatchedOrderSuccessResponse
     */
    'message': string;
    /**
     *
     * @type {GetUnmatchedOrderResult}
     * @memberof GetUnmatchedOrderSuccessResponse
     */
    'result': GetUnmatchedOrderResult;
}
/**
 * APIから受け取るpagingOptionsの情報
 * @export
 * @interface PagingOptions
 */
export interface PagingOptions {
    /**
     *
     * @type {number}
     * @memberof PagingOptions
     */
    'offset': number;
    /**
     *
     * @type {number}
     * @memberof PagingOptions
     */
    'nextOffset': number;
    /**
     *
     * @type {number}
     * @memberof PagingOptions
     */
    'pageSize': number;
    /**
     *
     * @type {number}
     * @memberof PagingOptions
     */
    'totalResultsAvailable': number;
    /**
     *
     * @type {number}
     * @memberof PagingOptions
     */
    'returnCount': number;
}
/**
 *
 * @export
 * @interface PutUnmatchedOrderRequest
 */
export interface PutUnmatchedOrderRequest {
    /**
     *
     * @type {string}
     * @memberof PutUnmatchedOrderRequest
     */
    'unmatchedOrderId': string;
    /**
     *
     * @type {string}
     * @memberof PutUnmatchedOrderRequest
     */
    'targetOrderId': string;
    /**
     *
     * @type {number}
     * @memberof PutUnmatchedOrderRequest
     */
    'updateAt': number;
}
/**
 *
 * @export
 * @interface RegisterUnmatchedOrderBusinessRequest
 */
export interface RegisterUnmatchedOrderBusinessRequest {
    /**
     * 置場名
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'warehouse': string;
    /**
     * 置場コード
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'warehouseNumber': string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'supplierName': string;
    /**
     * 仕入先コード
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'supplierNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'businessName': string;
    /**
     * 商品コード
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'businessNumber': string;
    /**
     * 容量
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'package': string;
    /**
     * リードタイム
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'leadTime'?: string;
    /**
     * リードタイムの単位
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'leadTimeUnit'?: string;
    /**
     * 標準在庫指数の上限
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'stdInventoryIndexMax'?: string;
    /**
     * 標準在庫指数の下限
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'stdInventoryIndexMin'?: string;
    /**
     * 標準在庫指数の単位
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'stdInventoryIndexUnit'?: string;
    /**
     * 単位
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'unit'?: string | null;
    /**
     * 最小発注数量
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'moq'?: string | null;
    /**
     * 製造社
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'manufacturer'?: string | null;
    /**
     * 発注単位
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'orderPackage'?: string | null;
    /**
     * 仕入担当者ID一覧
     * @type {Array<string>}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'aggregateBusinessResponsibleUserIdList'?: Array<string>;
    /**
     * ユーザー任意項目の一意番号
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'userUniqueNumber'?: string | null;
    /**
     * 発注番号
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'orderNumber': string;
    /**
     * 発注作成日
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'createdOrderDate'?: string | null;
    /**
     * 希望納品日
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'desiredDeliveryDate': string;
    /**
     * 到着予定日
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'estimatedTimeOfArrival': string;
    /**
     * 発注数量
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'orderAmount': string;
    /**
     * 発注ステータス
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'orderStatus': string;
    /**
     * 未照合発注ID
     * @type {string}
     * @memberof RegisterUnmatchedOrderBusinessRequest
     */
    'unmatchedOrderId': string;
}
/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     *
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     *
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     *
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     *
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}
/**
 *
 * @export
 * @interface UnmatchedOrderInfo
 */
export interface UnmatchedOrderInfo {
    /**
     *
     * @type {string}
     * @memberof UnmatchedOrderInfo
     */
    'unmatchedOrderId': string;
    /**
     *
     * @type {string}
     * @memberof UnmatchedOrderInfo
     */
    'warehouseNumber': string;
    /**
     *
     * @type {string}
     * @memberof UnmatchedOrderInfo
     */
    'warehouse': string;
    /**
     *
     * @type {string}
     * @memberof UnmatchedOrderInfo
     */
    'supplierNumber': string;
    /**
     *
     * @type {string}
     * @memberof UnmatchedOrderInfo
     */
    'supplierName': string;
    /**
     *
     * @type {string}
     * @memberof UnmatchedOrderInfo
     */
    'businessNumber': string;
    /**
     *
     * @type {string}
     * @memberof UnmatchedOrderInfo
     */
    'businessName': string;
    /**
     *
     * @type {string}
     * @memberof UnmatchedOrderInfo
     */
    'package': string;
    /**
     *
     * @type {string}
     * @memberof UnmatchedOrderInfo
     */
    'orderNumber'?: string | null;
    /**
     *
     * @type {string}
     * @memberof UnmatchedOrderInfo
     */
    'orderIssuedNumber'?: string | null;
    /**
     *
     * @type {number}
     * @memberof UnmatchedOrderInfo
     */
    'createdOrderDate'?: number | null;
    /**
     *
     * @type {number}
     * @memberof UnmatchedOrderInfo
     */
    'desiredDeliveryDate'?: number | null;
    /**
     *
     * @type {number}
     * @memberof UnmatchedOrderInfo
     */
    'estimatedTimeOfArrival'?: number | null;
    /**
     *
     * @type {string}
     * @memberof UnmatchedOrderInfo
     */
    'orderAmount'?: string | null;
    /**
     *
     * @type {string}
     * @memberof UnmatchedOrderInfo
     */
    'orderStatus'?: string | null;
    /**
     *
     * @type {string}
     * @memberof UnmatchedOrderInfo
     */
    'errorReason': string;
    /**
     *
     * @type {string}
     * @memberof UnmatchedOrderInfo
     */
    'unmatchedOrderStatus': UnmatchedOrderInfoUnmatchedOrderStatusEnum;
    /**
     *
     * @type {string}
     * @memberof UnmatchedOrderInfo
     */
    'matchedOrderId'?: string | null;
    /**
     *
     * @type {number}
     * @memberof UnmatchedOrderInfo
     */
    'createAt': number;
    /**
     *
     * @type {number}
     * @memberof UnmatchedOrderInfo
     */
    'updateAt': number;
}

export const UnmatchedOrderInfoUnmatchedOrderStatusEnum = {
    Pending: 'pending',
    Matched: 'matched',
    Registered: 'registered',
    Deleted: 'deleted',
    Unknown: 'unknown'
} as const;

export type UnmatchedOrderInfoUnmatchedOrderStatusEnum = typeof UnmatchedOrderInfoUnmatchedOrderStatusEnum[keyof typeof UnmatchedOrderInfoUnmatchedOrderStatusEnum];


/**
 * UnmatchedOrderApi - axios parameter creator
 * @export
 */
export const UnmatchedOrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary 未照合発注を一括登録する
         * @param {BulkRegisterOrderBusinessesFromUnmatchedRequest} bulkRegisterOrderBusinessesFromUnmatchedRequest 未照合取引登録情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkRegisterOrderBusinessesFromUnmatched: async (bulkRegisterOrderBusinessesFromUnmatchedRequest: BulkRegisterOrderBusinessesFromUnmatchedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkRegisterOrderBusinessesFromUnmatchedRequest' is not null or undefined
            assertParamExists('bulkRegisterOrderBusinessesFromUnmatched', 'bulkRegisterOrderBusinessesFromUnmatchedRequest', bulkRegisterOrderBusinessesFromUnmatchedRequest)
            const localVarPath = `/unmatched-order/register/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkRegisterOrderBusinessesFromUnmatchedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 未照合・差異一覧情報を一括削除する
         * @param {BulkDeleteUnmatchedOrderRequest} bulkDeleteUnmatchedOrderRequest 一括削除する未照合・差異一覧のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUnmatchedOrderBulk: async (bulkDeleteUnmatchedOrderRequest: BulkDeleteUnmatchedOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkDeleteUnmatchedOrderRequest' is not null or undefined
            assertParamExists('deleteUnmatchedOrderBulk', 'bulkDeleteUnmatchedOrderRequest', bulkDeleteUnmatchedOrderRequest)
            const localVarPath = `/unmatched-order/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDeleteUnmatchedOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 突合先候補の既存発注を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExistingOrders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/unmatched-order/existing-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 未照合・差異一覧情報を取得する
         * @param {number} limit 表示制限
         * @param {number} offset オフセット
         * @param {any} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnmatchedOrder: async (limit: number, offset: number, filterItem?: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getUnmatchedOrder', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getUnmatchedOrder', 'offset', offset)
            const localVarPath = `/unmatched-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 未照合差異のフィルタ情報を取得する
         * @param {string} column 取得するカラム
         * @param {string} [keyword] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnmatchedOrderFilter: async (column: string, keyword?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'column' is not null or undefined
            assertParamExists('getUnmatchedOrderFilter', 'column', column)
            const localVarPath = `/unmatched-order/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (column !== undefined) {
                localVarQueryParameter['column'] = column;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 未照合・差異一覧情報を更新する
         * @param {PutUnmatchedOrderRequest} putUnmatchedOrderRequest 未照合・差異一覧の更新情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUnmatchedOrder: async (putUnmatchedOrderRequest: PutUnmatchedOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'putUnmatchedOrderRequest' is not null or undefined
            assertParamExists('putUnmatchedOrder', 'putUnmatchedOrderRequest', putUnmatchedOrderRequest)
            const localVarPath = `/unmatched-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putUnmatchedOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary 未照合発注を登録する
         * @param {RegisterUnmatchedOrderBusinessRequest} registerUnmatchedOrderBusinessRequest 未照合取引登録情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUnmatchedOrderBusiness: async (registerUnmatchedOrderBusinessRequest: RegisterUnmatchedOrderBusinessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerUnmatchedOrderBusinessRequest' is not null or undefined
            assertParamExists('registerUnmatchedOrderBusiness', 'registerUnmatchedOrderBusinessRequest', registerUnmatchedOrderBusinessRequest)
            const localVarPath = `/unmatched-order/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerUnmatchedOrderBusinessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnmatchedOrderApi - functional programming interface
 * @export
 */
export const UnmatchedOrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnmatchedOrderApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary 未照合発注を一括登録する
         * @param {BulkRegisterOrderBusinessesFromUnmatchedRequest} bulkRegisterOrderBusinessesFromUnmatchedRequest 未照合取引登録情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkRegisterOrderBusinessesFromUnmatched(bulkRegisterOrderBusinessesFromUnmatchedRequest: BulkRegisterOrderBusinessesFromUnmatchedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkRegisterOrderBusinessesFromUnmatchedSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkRegisterOrderBusinessesFromUnmatched(bulkRegisterOrderBusinessesFromUnmatchedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnmatchedOrderApi.bulkRegisterOrderBusinessesFromUnmatched']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary 未照合・差異一覧情報を一括削除する
         * @param {BulkDeleteUnmatchedOrderRequest} bulkDeleteUnmatchedOrderRequest 一括削除する未照合・差異一覧のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUnmatchedOrderBulk(bulkDeleteUnmatchedOrderRequest: BulkDeleteUnmatchedOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkDeleteUnmatchedOrderSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUnmatchedOrderBulk(bulkDeleteUnmatchedOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnmatchedOrderApi.deleteUnmatchedOrderBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary 突合先候補の既存発注を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExistingOrders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExistingOrdersSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExistingOrders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnmatchedOrderApi.getExistingOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary 未照合・差異一覧情報を取得する
         * @param {number} limit 表示制限
         * @param {number} offset オフセット
         * @param {any} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnmatchedOrder(limit: number, offset: number, filterItem?: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnmatchedOrderSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnmatchedOrder(limit, offset, filterItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnmatchedOrderApi.getUnmatchedOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary 未照合差異のフィルタ情報を取得する
         * @param {string} column 取得するカラム
         * @param {string} [keyword] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnmatchedOrderFilter(column: string, keyword?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnmatchedOrderFilterSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnmatchedOrderFilter(column, keyword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnmatchedOrderApi.getUnmatchedOrderFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary 未照合・差異一覧情報を更新する
         * @param {PutUnmatchedOrderRequest} putUnmatchedOrderRequest 未照合・差異一覧の更新情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putUnmatchedOrder(putUnmatchedOrderRequest: PutUnmatchedOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putUnmatchedOrder(putUnmatchedOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnmatchedOrderApi.putUnmatchedOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary 未照合発注を登録する
         * @param {RegisterUnmatchedOrderBusinessRequest} registerUnmatchedOrderBusinessRequest 未照合取引登録情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerUnmatchedOrderBusiness(registerUnmatchedOrderBusinessRequest: RegisterUnmatchedOrderBusinessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerUnmatchedOrderBusiness(registerUnmatchedOrderBusinessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnmatchedOrderApi.registerUnmatchedOrderBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UnmatchedOrderApi - factory interface
 * @export
 */
export const UnmatchedOrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnmatchedOrderApiFp(configuration)
    return {
        /**
         *
         * @summary 未照合発注を一括登録する
         * @param {BulkRegisterOrderBusinessesFromUnmatchedRequest} bulkRegisterOrderBusinessesFromUnmatchedRequest 未照合取引登録情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkRegisterOrderBusinessesFromUnmatched(bulkRegisterOrderBusinessesFromUnmatchedRequest: BulkRegisterOrderBusinessesFromUnmatchedRequest, options?: any): AxiosPromise<BulkRegisterOrderBusinessesFromUnmatchedSuccessResponse> {
            return localVarFp.bulkRegisterOrderBusinessesFromUnmatched(bulkRegisterOrderBusinessesFromUnmatchedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 未照合・差異一覧情報を一括削除する
         * @param {BulkDeleteUnmatchedOrderRequest} bulkDeleteUnmatchedOrderRequest 一括削除する未照合・差異一覧のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUnmatchedOrderBulk(bulkDeleteUnmatchedOrderRequest: BulkDeleteUnmatchedOrderRequest, options?: any): AxiosPromise<BulkDeleteUnmatchedOrderSuccessResponse> {
            return localVarFp.deleteUnmatchedOrderBulk(bulkDeleteUnmatchedOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 突合先候補の既存発注を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExistingOrders(options?: any): AxiosPromise<GetExistingOrdersSuccessResponse> {
            return localVarFp.getExistingOrders(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 未照合・差異一覧情報を取得する
         * @param {number} limit 表示制限
         * @param {number} offset オフセット
         * @param {any} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnmatchedOrder(limit: number, offset: number, filterItem?: any, options?: any): AxiosPromise<GetUnmatchedOrderSuccessResponse> {
            return localVarFp.getUnmatchedOrder(limit, offset, filterItem, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 未照合差異のフィルタ情報を取得する
         * @param {string} column 取得するカラム
         * @param {string} [keyword] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnmatchedOrderFilter(column: string, keyword?: string, options?: any): AxiosPromise<GetUnmatchedOrderFilterSuccessResponse> {
            return localVarFp.getUnmatchedOrderFilter(column, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 未照合・差異一覧情報を更新する
         * @param {PutUnmatchedOrderRequest} putUnmatchedOrderRequest 未照合・差異一覧の更新情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUnmatchedOrder(putUnmatchedOrderRequest: PutUnmatchedOrderRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.putUnmatchedOrder(putUnmatchedOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 未照合発注を登録する
         * @param {RegisterUnmatchedOrderBusinessRequest} registerUnmatchedOrderBusinessRequest 未照合取引登録情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUnmatchedOrderBusiness(registerUnmatchedOrderBusinessRequest: RegisterUnmatchedOrderBusinessRequest, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.registerUnmatchedOrderBusiness(registerUnmatchedOrderBusinessRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UnmatchedOrderApi - object-oriented interface
 * @export
 * @class UnmatchedOrderApi
 * @extends {BaseAPI}
 */
export class UnmatchedOrderApi extends BaseAPI {
    /**
     *
     * @summary 未照合発注を一括登録する
     * @param {BulkRegisterOrderBusinessesFromUnmatchedRequest} bulkRegisterOrderBusinessesFromUnmatchedRequest 未照合取引登録情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnmatchedOrderApi
     */
    public bulkRegisterOrderBusinessesFromUnmatched(bulkRegisterOrderBusinessesFromUnmatchedRequest: BulkRegisterOrderBusinessesFromUnmatchedRequest, options?: RawAxiosRequestConfig) {
        return UnmatchedOrderApiFp(this.configuration).bulkRegisterOrderBusinessesFromUnmatched(bulkRegisterOrderBusinessesFromUnmatchedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 未照合・差異一覧情報を一括削除する
     * @param {BulkDeleteUnmatchedOrderRequest} bulkDeleteUnmatchedOrderRequest 一括削除する未照合・差異一覧のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnmatchedOrderApi
     */
    public deleteUnmatchedOrderBulk(bulkDeleteUnmatchedOrderRequest: BulkDeleteUnmatchedOrderRequest, options?: RawAxiosRequestConfig) {
        return UnmatchedOrderApiFp(this.configuration).deleteUnmatchedOrderBulk(bulkDeleteUnmatchedOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 突合先候補の既存発注を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnmatchedOrderApi
     */
    public getExistingOrders(options?: RawAxiosRequestConfig) {
        return UnmatchedOrderApiFp(this.configuration).getExistingOrders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 未照合・差異一覧情報を取得する
     * @param {number} limit 表示制限
     * @param {number} offset オフセット
     * @param {any} [filterItem] フィルター対象の項目と情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnmatchedOrderApi
     */
    public getUnmatchedOrder(limit: number, offset: number, filterItem?: any, options?: RawAxiosRequestConfig) {
        return UnmatchedOrderApiFp(this.configuration).getUnmatchedOrder(limit, offset, filterItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 未照合差異のフィルタ情報を取得する
     * @param {string} column 取得するカラム
     * @param {string} [keyword] キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnmatchedOrderApi
     */
    public getUnmatchedOrderFilter(column: string, keyword?: string, options?: RawAxiosRequestConfig) {
        return UnmatchedOrderApiFp(this.configuration).getUnmatchedOrderFilter(column, keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 未照合・差異一覧情報を更新する
     * @param {PutUnmatchedOrderRequest} putUnmatchedOrderRequest 未照合・差異一覧の更新情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnmatchedOrderApi
     */
    public putUnmatchedOrder(putUnmatchedOrderRequest: PutUnmatchedOrderRequest, options?: RawAxiosRequestConfig) {
        return UnmatchedOrderApiFp(this.configuration).putUnmatchedOrder(putUnmatchedOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary 未照合発注を登録する
     * @param {RegisterUnmatchedOrderBusinessRequest} registerUnmatchedOrderBusinessRequest 未照合取引登録情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnmatchedOrderApi
     */
    public registerUnmatchedOrderBusiness(registerUnmatchedOrderBusinessRequest: RegisterUnmatchedOrderBusinessRequest, options?: RawAxiosRequestConfig) {
        return UnmatchedOrderApiFp(this.configuration).registerUnmatchedOrderBusiness(registerUnmatchedOrderBusinessRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



